import { Injectable } from '@angular/core';
import { ParkingType, ParkingTypeDto } from '../../models/parking/parking-type.model';

@Injectable({
    providedIn: 'root',
})
export class MapperParkingTypeService {
    
    constructor() { }

    public mapParkingTypeFromDto(dto: ParkingTypeDto): ParkingType {
        return {
            id: dto.Id || 0,
            name: dto.Name || '',
            vehicleType: dto.VehicleType || '',
            isOnline: dto.IsOnline || false
        };
    }

    public mapParkingTypeToDto(model: ParkingType): ParkingTypeDto {
        return {
            Id: model.id,
            Name: model.name,
            VehicleType: model.vehicleType,
            IsOnline: model.isOnline
        };
    }
}
